import { DataTable } from "@/components/custom/data-table";
import { Box, Stack, styled } from "@mui/material";
import { useProductCategories } from "@/hooks/use-products-categories";
import { CustomButton } from "@/components/custom/custom-button";
import { getCategoryColumns } from "./_components/category-column";
import { useState } from "react";
import NewProductCategoryDialog from "./_components/category-dialog";
import {
  createProductCategory,
  updateProductCategory,
} from "@/services/pricing-config.service";
import CustomSearchInput from "@/components/custom/custom-search-input";
import { useSearchParams } from "react-router-dom";
import CustomPagination from "@/components/custom/custom-pagination";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const ProductsCategories = () => {
  const [newProductCategoryOpen, setNewProductCategoryOpen] = useState(false);
  const [editCategory, setEditCategory] = useState(null);

  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue,
  };

  const {
    data: categories,
    isLoading,
    isError,
  } = useProductCategories(true, queryParams);

  const handleEditClick = (category) => setEditCategory(category);
  const handleEditClose = () => setEditCategory(null);

  return (
    <RootWrapper>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={3}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search product categories..."
            />
          </Stack>

          <CustomButton
            variantType="outline"
            onClick={() => setNewProductCategoryOpen(true)}
            sx={{ height: 35 }}
          >
            New Category
          </CustomButton>
        </Stack>

        <DataTable
          data={categories?.data?.data ?? []}
          columns={getCategoryColumns(handleEditClick)}
          isLoading={isLoading}
          isError={isError}
        />

        <CustomPagination
          total={categories?.data?.totalCount ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>

      <NewProductCategoryDialog
        open={newProductCategoryOpen}
        onClose={() => setNewProductCategoryOpen(false)}
        mutationFn={createProductCategory}
      />

      <NewProductCategoryDialog
        open={Boolean(editCategory)}
        onClose={handleEditClose}
        category={editCategory}
        mutationFn={(payload) =>
          updateProductCategory({ id: editCategory?.id, ...payload })
        }
      />
    </RootWrapper>
  );
};

export default ProductsCategories;
